/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import cx from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import HeaderButton from 'components/header/button';
// eslint-disable-next-line no-restricted-imports
import { NotificationsPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
import React, { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
// eslint-disable-next-line no-restricted-imports
import {
  ClassicBackboneModelPartial,
  ClassicMemberModelPartial,
  getClassicMemberModel,
  getClassicModelCache,
} from 'selectors/classic';
// eslint-disable-next-line no-restricted-imports
import { isPopoverShown } from 'selectors/popovers';
import styles from './styles.less';

import Controller from 'scripts/controller/index.coffee';

const HeaderNotificationsMenuPromise = import(/* webpackChunkName: "gamma-notifications-menu-popover" */ 'components/popovers/header-notifications-menu');
const HeaderNotificationsMenu = lazy(() => HeaderNotificationsMenuPromise);

interface NotificationsMenuButtonProps {
  model: ClassicMemberModelPartial | null;
  modelCache: ClassicBackboneModelPartial;
  isActive: boolean;
  onClick: () => void;
}

interface NotificationsMenuButtonState {
  unreadCount: number;
  otherNotifications: boolean;
}

class ClassicNotificationsMenuButton extends React.Component<
  NotificationsMenuButtonProps,
  NotificationsMenuButtonState
> {
  notificationsMenuButtonRef = React.createRef<HTMLButtonElement>();
  state = {
    unreadCount: 0,
    otherNotifications: false,
  };

  componentDidMount() {
    if (this.props.model) {
      this.registerModelCacheListeners();
    }
  }

  componentDidUpdate(
    prevProps: NotificationsMenuButtonProps,
    prevState: NotificationsMenuButtonState,
  ) {
    if (!prevProps.model && this.props.model) {
      this.registerModelCacheListeners();
    }
    if (prevState.unreadCount !== this.state.unreadCount) {
      Controller.title(); // holy cross-the-streams, Batman
    }
  }

  private registerModelCacheListeners() {
    const { model, modelCache } = this.props;
    modelCache.on(
      'add:Notification change:Notification remove:Notification',
      this.updateNotificationState,
    );
    model!.on(
      'change:showNps change:marketingOptIn change:notificationsCount change:messagesDismissed',
      this.updateNotificationState,
    );
    model!.notificationsSeenState.on(
      'change:lastSeenNotificationGroup',
      this.updateNotificationState,
    );
    this.updateNotificationState();
  }

  componentWillUnmount() {
    const { model, modelCache } = this.props;
    modelCache.off(
      'add:Notification change:Notification remove:Notification',
      this.updateNotificationState,
    );
    model!.off(
      'change:showNps change:marketingOptIn change:notificationsCount change:messagesDismissed',
      this.updateNotificationState,
    );
    model!.notificationsSeenState.off(
      'change:lastSeenNotificationGroup',
      this.updateNotificationState,
    );
  }

  private updateNotificationState = () => {
    const { model, modelCache } = this.props;
    const unreadCount = model!.unreadNotifications(modelCache);
    const otherNotifications =
      unreadCount === 0 &&
      (model!.shouldShowSurvey() ||
        model!.shouldShowMarketingOptIn() ||
        model!.shouldShowNoticeOfTosChange());
    this.setState({
      unreadCount,
      otherNotifications,
    });
  };

  render() {
    const { isActive, onClick } = this.props;
    const { unreadCount, otherNotifications } = this.state;

    return (
      <>
        <HeaderButton
          className={cx({
            [styles.newNotifications]: unreadCount > 0,
            [styles.hasOtherNotifications]: otherNotifications,
          })}
          icon={IconName.Notification}
          onClick={onClick}
          ref={this.notificationsMenuButtonRef}
          testId={HeaderTestIds.NotificationsButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderNotificationsMenu
              target={() => this.notificationsMenuButtonRef.current}
            />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    model: getClassicMemberModel(state),
    modelCache: getClassicModelCache(),
    isActive: isPopoverShown(state, NotificationsPopoverId),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>) => {
  return {
    onClick() {
      dispatch(showPopover({ name: NotificationsPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClassicNotificationsMenuButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/notifications-menu-button/classic-notifications-menu-button.tsx